import DocumentPreview from "../components/ui/enterprise1/DocumentPreview";
import document1 from "../assests/HPE/enterpriseone/smb-a/webp/zip-document-1.webp";
import document2 from "../assests/HPE/enterpriseone/smb-a/webp/zip-document-2.webp";
import downloadIcon from "../assests/HPE/enterpriseone/smb-a/download.svg";
import ZertoDocumentPreview from "../components/ui/zerto/ZertoDocumentPreview";
import CardHeader from "../components/ui/enterprise1/CardHeader";
import EnterpriseHeader from "../components/ui/enterprise1/EnterpriseHeader";
import technicalpdf from "../assests/HPE/enterpriseone/smb-a/pdf/Technical Whitepaper.pdf";
import ransomwarepdf from "../assests/HPE/enterpriseone/smb-a/pdf/Ransomware Resilience Brief.pdf";
import zertoFile from "../assests/HPE/enterpriseone/smb-a/zerto.zip";
import Layout from "../components/layout/Layout";

const ZertoThankyouOne = () => {
  const docs = [
    {
      img: document1,
      title: "Technical Whitepaper",
      pages: "11 pages · PDF",
      file: technicalpdf,
    },
    {
      img: document2,
      title: "Ransomware Resilience Brief",
      pages: "4 pages · PDF",
      file: ransomwarepdf,
    },
  ];

  return (
    <Layout title="HPE Zerto Software" variant="enterprise">
      <div className="w-full min-h-screen bg-navy-blue-01">
        {/* HEADER */}
        <div className="flex flex-col md:items-center gap-4 mb-10 md:mb-16 max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto">
          <CardHeader
            title="Your resource pack is ready"
            description="Click below to download each document. If downloads do not start
          automatically, check your email."
          />
        </div>

        {/* MAIN SECTION */}
        <div className="max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto flex-col flex gap-3 md:gap-5">
          <div className="flex flex-col md:flex-row justify-between gap-0 md:gap-12 2xl:gap-[96px] w-full ">
            {/* LEFT */}
            <div className=" relative w-full max-w-[320px] sm:max-w-[384px] h-[310px] mx-auto flex flex-col gap-4">
              <ZertoDocumentPreview
                documents={docs}
                svgHeight="1830x"
                zipSize="6.30MB"
              />
            </div>
            {/* RIGHT */}

            <div className="flex flex-col flex-1 gap-12 md:gap-0">
              <a href={zertoFile} download>
                <button className="mx-auto block md:hidden max-w-[320px] sm:max-w-[384px] -mt-3 md:mt-0 w-full p-3 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 text-white font-medium hover:opacity-90 transition text-[14px] leading-[22px] font-inter">
                  Download all
                </button>
              </a>
              <div className="w-full md:flex-1 bg-green-03 rounded-[16px] p-4 md:p-8 flex flex-col gap-6">
                <p className="text-grey-01 text-[14px] leading-[22px] md:text-[16px] md:leading-[24px] font-google">
                  You can also download files individually
                </p>
                {/* LIST */}
                <div className="flex flex-col">
                  {docs.map((doc, i) => (
                    <div key={i}>
                      {/* ITEM */}
                      <div className="flex items-center justify-between py-5">
                        {/* LEFT CONTENT */}
                        <div className="flex items-center gap-3">
                          <div className="w-[42px] h-[42px] flex items-center justify-center rounded-md bg-navy-blue-04">
                            <img
                              src={doc.img}
                              alt=""
                              className="w-full h-full object-cover rounded-sm"
                            />
                          </div>
                          <div>
                            <p className="text-grey-01 font-medium text-[14px] leading-[20px] md:text-[16px] md:leading-[22px] font-google">
                              {doc.title}
                            </p>
                            <p className="text-grey-03 text-[10px] leading-[18px] md:text-[12px] md:leading-[20px] font-inter">
                              {doc.pages}
                            </p>
                          </div>
                        </div>
                        {/* DOWNLOAD ICON */}
                        <a
                          href={doc.file}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={downloadIcon} alt="" />
                        </a>
                      </div>
                      {/* DIVIDER */}
                      {i !== docs.length - 1 && (
                        <div className="w-full h-[1px] border-white/10 border-dashed border-t" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <a href={zertoFile} download>
            <button className="hidden md:block max-w-[384px] w-full p-3 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 text-white font-medium hover:opacity-90 transition text-[14px] leading-[22px]">
              Download all
            </button>
          </a>
        </div>
      </div>
    </Layout>
  );
};
export default ZertoThankyouOne;
